import { render, staticRenderFns } from "./preRegistList.vue?vue&type=template&id=c2717b2a&scoped=true&"
import script from "./preRegistList.vue?vue&type=script&lang=js&"
export * from "./preRegistList.vue?vue&type=script&lang=js&"
import style0 from "./preRegistList.vue?vue&type=style&index=0&id=c2717b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2717b2a",
  null
  
)

export default component.exports